module.exports = "/images/popup-minus.png?ee5ab78ab25e7e613495d0f7e8919d6a";